import React from 'react';
import { DataGrid, GridColDef } from '@mui/x-data-grid';
import pallet from '../../../layouts/pallet';
import { dataGridSx } from '../../common/styled/DataGrid';
import tableColumnUtils from '../../../utils/tableColumnUtils';
import { PageWrapper } from '../../common/styled';
import CustomDataGridToolbar from '../../common/components/CustomDataGridToolbar';

const DailyBookTable = ({
  DailyFeeBookReportData,
  columnsToHide = []
}: {
  DailyFeeBookReportData: any;
  columnsToHide?: string[];
}) => {
  const uniqueKeys = tableColumnUtils.extractUniqueKeys(DailyFeeBookReportData);

  const dynamicColumns: GridColDef[] =
    tableColumnUtils.createColumnsFromKeys(uniqueKeys);

  const visibleColumns = dynamicColumns.filter(
    (col) => !columnsToHide.includes(col.field)
  );

  const columnsToDisplay: GridColDef[] =
    tableColumnUtils.getColumnsToDisplay(visibleColumns);

  return (
    <PageWrapper>
      <DataGrid
        rowHeight={50}
        rows={DailyFeeBookReportData}
        columns={columnsToDisplay}
        getRowId={(row) => row['Sr. No.']}
        disableRowSelectionOnClick
        pageSizeOptions={tableColumnUtils.PAGE_SIZE_OPTIONS}
        initialState={tableColumnUtils.DATA_GRID_INITIAL_STATE}
        showToolbar
        slots={{ toolbar: CustomDataGridToolbar }}
        slotProps={{
          toolbar: {
            printOptions: { disableToolbarButton: true },
            showQuickFilter: true
          }
        }}
        sx={{
          ...dataGridSx(pallet),
          '& .MuiDataGrid-virtualScroller': {
            overflowY: 'auto'
          }
        }}
      />
    </PageWrapper>
  );
};

export default DailyBookTable;
